export const ORDER_STATUS_TYPES = {
    READY_FOR_PICKUP: 'READY_FOR_PICKUP',
    PICKUP_STARTED: 'PICKUP_STARTED',
    CUSTOMER_WAITING: 'CUSTOMER_WAITING',
    EMPLOYEE_IN_TRANSIT: 'EMPLOYEE_IN_TRANSIT',
    COMPLETED: 'COMPLETED'
}